import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Card, Col } from 'reactstrap'

import { REPO_KOMODITAS, REPO_KOMODITAS_LIST, URL_406 } from 'utils/pathUrl'

import IcSuccessTrx from 'assets/images/success-trx.png'
import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import { useLocalStorageTable as storage } from 'hooks/useLocalStorageTable'
import { BUSINESS_AUTOREPO, MANAGE } from 'utils/subjectActions'
import { useGetRepoListQuery } from './commodityRepoApiSlice'

const CommodityRepo = () => {
  const nav = useNavigate()
  const location = useLocation()
  const [successTrx, setSuccessTrx] = useState(false)
  const [activeTab, setActiveTab] = useState('repo')

  const { options } = storage('auto_repo_table')
  const repoList = useGetRepoListQuery(options)

  const ability = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_AUTOREPO,
  })

  useEffect(() => {
    if (location?.pathname === REPO_KOMODITAS) {
      setActiveTab('repo')
    } else {
      setActiveTab('list')
    }
  }, [location])

  if (!ability) {
    return <Navigate to={URL_406} replace={true} />
  }

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
    if (tabKey === 'list') {
      nav(REPO_KOMODITAS_LIST)
    } else {
      nav(REPO_KOMODITAS)
    }
  }

  return (
    <div className="w-100 px-3 pb-3">
      {successTrx ? (
        <Col>
          <Card
            className="m-0 m-auto d-flex justify-content-center align-items-center mt-3 gap-3 p-5 border-0 shadow-sm"
            style={{ maxWidth: '640px' }}
          >
            <img src={IcSuccessTrx} alt="success" width={280} height={182} />
            <div className="text-sm text-center">
              Pengajuan Repo kamu telah berhasil dan sedang di pelajari oleh Tim
              kami. Setelah selesai kami akan memberitahu kamu segera.
            </div>
            <CustomButton
              onClick={() => {
                nav(REPO_KOMODITAS, { replace: true })
                repoList.refetch()
                setSuccessTrx(false)
              }}
              color="primary"
              className="w-50"
            >
              Kembali ke Repo Barang
            </CustomButton>
          </Card>
        </Col>
      ) : (
        <div>
          <div className="d-flex align-items-start gap-2 pt-3">
            <BreadCrumbs breadCrumbActive={'Repo'} />
          </div>

          <Card body className="border-0 shadow-sm">
            <div className="mb-2 d-flex justify-content-start">
              <PMBTabSwitcher
                activeTab={activeTab}
                tabs={[
                  { key: 'repo', label: 'Repo Barang' },
                  {
                    key: 'list',
                    label: `Daftar Pengajuan Repo (${
                      repoList?.data?.totalItems ?? 0
                    })`,
                  },
                ]}
                onTabChange={handleTabChange}
                testId="repo-tab"
              />
            </div>
            <Outlet context={[setSuccessTrx]} />
          </Card>
        </div>
      )}
    </div>
  )
}

export default CommodityRepo
